import React, { useState } from "react";
import styles from "../styles/Wait.module.css";

export default function UIDemo() {
  // Existing waits
  const [delayedContentMsg, setDelayedContentMsg] = useState("");
  const [delayedContentActive, setDelayedContentActive] = useState(false);
  const [delayedElementVisible, setDelayedElementVisible] = useState(false);
  const [delayedElementActive, setDelayedElementActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // NEW: Explicit & Fluent demo states
  const [boxes, setBoxes] = useState([]);
  const [showInput, setShowInput] = useState(false);

  function getRandomDelay() {
    return Math.floor(Math.random() * 2500) + 1000;
  }

  // Delayed Content
  function handleLoad3s() {
    setDelayedContentActive(true);
    setIsLoading(true);
    setDelayedContentMsg("");

    setTimeout(() => {
      setIsLoading(false);
      setDelayedContentMsg("Loaded after 30 seconds!");
    }, 30000);
  }

  function handleLoadRandom() {
    setDelayedContentActive(true);
    setIsLoading(true);
    setDelayedContentMsg("");

    const delay = getRandomDelay();

    setTimeout(() => {
      setIsLoading(false);
      setDelayedContentMsg(`Loaded after ${(delay / 1000).toFixed(2)} seconds!`);
    }, delay);
  }

  // Delayed Element
  function handleShow5s() {
    setDelayedElementActive(true);
    setDelayedElementVisible(false);
    setTimeout(() => setDelayedElementVisible(true), 5000);
  }

  function handleHideElement() {
    setDelayedElementActive(false);
    setDelayedElementVisible(false);
  }

  // NEW: Explicit Wait demo (multiple boxes)
  function handleAddBox() {
    setTimeout(() => {
      setBoxes(prev => [...prev, `Box ${prev.length + 1}`]);
    }, 5000);
  }

  // NEW: Fluent Wait demo (input reveal)
  function handleRevealInput() {
    setTimeout(() => setShowInput(true), 8000);
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.centered}>

        {/* EXISTING CARD */}
        <div className={styles.card} id="wait-handling-section">
          <div className={styles.sectionTitle}>Wait Handling</div>

          <div className={styles.subTitle}>Delayed Content</div>
          <div className={styles.buttonRow}>
            <button className={styles.button} onClick={handleLoad3s} id="load-3s-btn">
              Load Content (30s Delay)
            </button>
            <button className={styles.button} onClick={handleLoadRandom} id="load-random-btn">
              Load Content (Random Delay)
            </button>
          </div>

          {delayedContentActive && (
            <div className={styles.result} id="delayed-content-result">
              {isLoading ? <div className={styles.loader}></div> : delayedContentMsg}
            </div>
          )}

          <div className={styles.subTitle}>Delayed Element</div>
          <div className={styles.buttonRow}>
            <button className={styles.button} onClick={handleShow5s} id="show-element-btn">
              Show Element (5s)
            </button>
            <button className={styles.button} onClick={handleHideElement} id="hide-element-btn">
              Hide Element
            </button>
          </div>

          {delayedElementActive && delayedElementVisible && (
            <div className={styles.result} id="delayed-element-text">
              This element appears after 5 seconds!
            </div>
          )}
        </div>

        {/* NEW CARD – EXPLICIT & FLUENT WAIT */}
        <div className={styles.card} id="explicit-fluent-card">
          <div className={styles.sectionTitle}>Explicit & Fluent Wait</div>

          <div className={styles.subTitle}>Explicit Wait – Dynamic Boxes</div>
          <button
            className={styles.button}
            onClick={handleAddBox}
            id="addBoxBtn"
          >
            Add a New Box
          </button>

          <div id="boxContainer" className={styles.result}>
            {boxes.map((_, index) => (
              <div
                key={index}
                className={styles.box}
                aria-label={`box-${index + 1}`}
              ></div>
            ))}
          </div>


          <div className={styles.subTitle}>Fluent Wait – Reveal Input</div>
          <button
            className={styles.button}
            onClick={handleRevealInput}
            id="revealInputBtn"
          >
            Reveal a New Input
          </button>

          {showInput && (
            <input
              id="newInput"
              className={styles.input}
              placeholder="New Input Appeared"
            />
          )}
        </div>
      </div>
    </div>
  );
}
